// 自动注册components下的全局公共组件
export function setupVab(app) {
  // 参数：1. 目录  2. 是否加载子目录  3. 加载的正则匹配
  const Components = require.context(".", true, /\.vue$/);
  Components.keys()
    .map(Components)
    .forEach((item) => {
      app.component(item.default.name, item.default);
    });
}
